// components/ArticleList.tsx
import React from 'react';
import { TFunction } from 'next-i18next'
import { SeccionesPerfil, menuActividad, menuCuenta, menuOtros } from '@/objects/Menus';
import { MenuPerfil } from '@/objects/Menus';
import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import TituloDescripcion from '@/components/elements/TituloDescripcion';
import Subtitulo from '@/components/elements/Subtitulo';
import Texto from '@/components/elements/Texto';
import { black, gray, lightGray, primary, red, rojoerror, white } from '@/constants/Colors';
import { Badge } from '@mui/material';
import router from 'next/router';
interface Props {
  opcion: MenuPerfil;
  opcionActual: SeccionesPerfil;
  opcionSeleccionada: (opcion: SeccionesPerfil) => void;
  t: TFunction;
  numeroNotificaciones?: number;
}

const RowMenu: React.FC<Props> = ({ opcion, opcionActual, opcionSeleccionada, t, numeroNotificaciones }) => {
  const isSelected = opcion.clave_seccion === opcionActual;
  const isCerrarSesion = opcion.clave_seccion === 'cerrar-sesion';
  const color = isCerrarSesion ? red : (isSelected ? black : lightGray);
  const border = isSelected ? `4px solid ${primary}` : 'none';

  return (
    <div key={opcion.id} onClick={() => opcionSeleccionada(opcion.clave_seccion)  /*router.push('/dashboard/' + opcion.clave_seccion)*/}
      style={{ display: 'flex', alignItems: 'center', cursor: "pointer", borderRight: border, background: white, padding: "10px" }}>
      <div className="menu-perfil-icono" style={{ display: 'flex', alignItems: 'center', color: color, marginRight: "10px" }}>
        <Badge
          badgeContent={(numeroNotificaciones != undefined && numeroNotificaciones > 0) ? numeroNotificaciones : undefined}
          overlap="circular"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            marginRight: "3px",
            zIndex: 1,
            '.MuiBadge-badge': {
              backgroundColor: red,
              color: white,
              transform: 'scale(1) translate(50%, -50%)',
            },
          }}
        >
          {opcion.icono}
        </Badge>
      </div>
      <div className="menu-perfil-texto" style={{ display: 'flex', flexDirection: 'column' }}>
        <TituloDescripcion color={color}>{t(opcion.titulo)}</TituloDescripcion>
        <Texto fontWeight='300' color={color}>{t(opcion.subtitulo)} </Texto>
      </div>
    </div>
  );
};

export default RowMenu;
